var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page-outer',[_c('app-page-inner',{staticClass:"countdown"},[_c('com-text',{attrs:{"item":{ content: _vm.page.message.open }}}),_c('div',{staticClass:"countdown-widget"},[_c('flip-countdown',{attrs:{"deadline":_vm.countdown}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }